import React from "react";
import { Link } from "react-router-dom";
import { Header } from "../HomeScene";
import styles from "./BrandExperience.module.scss";

const BrandExperience = () => {
  return (
    <div>
      <Header />
      <div className={`${styles.banner} animate__animated animate__backInUp`}>
        {/* <img
          src={require("../../assets/images/logo.png")}
          className={styles.logoMob}
        /> */}
        <div className={styles.logoWeb}>Venture Beyond</div>
      </div>
      <div
        className={`${styles.bannerInfo} ${styles.actionBtnWrapper} animate__animated animate__bounceInUp animate__delay-1s`}
      >
        <div
          className={`${styles.actionBtn} ${styles.optionBtn} animate__animated animate__fadeIn animate__delay-1s`}
        >
          <Link to="/history">
            <div className={styles.btnText}>THE PENFOLDS STORY</div>
          </Link>
        </div>
        <div
          className={`${styles.actionBtn} ${styles.optionBtn} animate__animated animate__fadeIn animate__delay-1s`}
        >
          <Link to="/notes">
            <div className={styles.btnText}>THE PENFOLDS TASTE</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BrandExperience;
